import { ImageEntity } from '../../types';
import { NewStep, QuizValues } from './types';

export const cleanFooterMessage = () =>
  ({
    type: 'CLEAN_FOOTER_MESSAGE',
  } as const);

export const loadStepRequested = () =>
  ({
    type: 'LOAD_STEP_REQUESTED',
  } as const);

export const loadStepFailure = (err: Error) =>
  ({
    type: 'LOAD_STEP_FAILURE',
    payload: err,
    error: true,
  } as const);

export const loadStepSucceeded = (step: NewStep) =>
  ({
    type: 'LOAD_STEP_SUCCEEDED',
    payload: step,
  } as const);

export const saveAnswers = (form: QuizValues) =>
  ({
    type: 'SAVE_ANSWERS',
    payload: form,
  } as const);

export const toggleQuestions = (index: number) =>
  ({
    type: 'TOGGLE_QUESTIONS',
    payload: index,
  } as const);

export const gotoPreviousStep = (slug: string) =>
  ({
    type: 'GOTO_PREVIOUS_STEP',
    payload: slug,
  } as const);

export const setFooterMessage = (onChange: string, values: string[]) =>
  ({
    type: 'SET_FOOTER_MESSAGE',
    payload: {
      onChange,
      values,
    },
  } as const);

export const clearAnswers = () =>
  ({
    type: 'CLEAR_ANSWERS',
  } as const);

export const completeQuiz = () =>
  ({
    type: 'COMPLETE_QUIZ',
  } as const);

export const loadQuizImagesSucceeded = (images: { stepImages: ImageEntity[]; optionImages: ImageEntity[] }) =>
  ({
    type: 'LOAD_QUIZ_IMAGES_SUCCEEDED',
    payload: images,
  } as const);
